/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationCountDTOFromJSON, LocationCountDTOToJSON, } from './LocationCountDTO';
import { StatusCountDTOFromJSON, StatusCountDTOToJSON, } from './StatusCountDTO';
import { DateSearchCountDTOFromJSON, DateSearchCountDTOToJSON, } from './DateSearchCountDTO';
/**
 * Check if a given object implements the DashboardDTO interface.
 */
export function instanceOfDashboardDTO(value) {
    return true;
}
export function DashboardDTOFromJSON(json) {
    return DashboardDTOFromJSONTyped(json, false);
}
export function DashboardDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keywordScan': json['keywordScan'] == null ? undefined : (json['keywordScan'].map(StatusCountDTOFromJSON)),
        'storefrontScan': json['storefrontScan'] == null ? undefined : (json['storefrontScan'].map(StatusCountDTOFromJSON)),
        'keywordPool': json['keywordPool'] == null ? undefined : (json['keywordPool'].map(LocationCountDTOFromJSON)),
        'storefrontPool': json['storefrontPool'] == null ? undefined : (json['storefrontPool'].map(LocationCountDTOFromJSON)),
        'keywordLast7daysScan': json['keywordLast7daysScan'] == null ? undefined : (json['keywordLast7daysScan'].map(DateSearchCountDTOFromJSON)),
        'storeLast7daysScan': json['storeLast7daysScan'] == null ? undefined : (json['storeLast7daysScan'].map(DateSearchCountDTOFromJSON)),
    };
}
export function DashboardDTOToJSON(json) {
    return DashboardDTOToJSONTyped(json, false);
}
export function DashboardDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'keywordScan': value['keywordScan'] == null ? undefined : (value['keywordScan'].map(StatusCountDTOToJSON)),
        'storefrontScan': value['storefrontScan'] == null ? undefined : (value['storefrontScan'].map(StatusCountDTOToJSON)),
        'keywordPool': value['keywordPool'] == null ? undefined : (value['keywordPool'].map(LocationCountDTOToJSON)),
        'storefrontPool': value['storefrontPool'] == null ? undefined : (value['storefrontPool'].map(LocationCountDTOToJSON)),
        'keywordLast7daysScan': value['keywordLast7daysScan'] == null ? undefined : (value['keywordLast7daysScan'].map(DateSearchCountDTOToJSON)),
        'storeLast7daysScan': value['storeLast7daysScan'] == null ? undefined : (value['storeLast7daysScan'].map(DateSearchCountDTOToJSON)),
    };
}
